module.exports = __webpack_public_path__ + "static/01-icon-4b1936bf81090c07c5773ba05df01c15.png";